import { render, staticRenderFns } from "./unitSelect.vue?vue&type=template&id=2f673e0b&scoped=true"
import script from "./unitSelect.vue?vue&type=script&lang=js"
export * from "./unitSelect.vue?vue&type=script&lang=js"
import style0 from "./unitSelect.vue?vue&type=style&index=0&id=2f673e0b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f673e0b",
  null
  
)

export default component.exports